// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { locationSearchFormStyles } from "@keller/Overrides/Components/LocationSearchForm";
import { constants } from "@keller/XDL/constants";
import xScreen from "@keller/XDL/Utilities/xScreen";
import { css } from "styled-components";

locationSearchFormStyles.searchResultPhoneGridItem = {
    width: 11,
};

locationSearchFormStyles.searchResultContentGridItem = {
    width: [4, 4, 4, 4, 4],
    css: css`
        ${xScreen("lte", constants.locationSearchForm.breakpoints.xs)} {
            flex-basis: 50%;
            max-width: 50%;
        }
    `,
};

locationSearchFormStyles.searchResultGoogleMapsDirectionLinkGridItem = {
    width: [4, 4, 4, 4, 4],
    css: css`
        ${xScreen("lte", constants.locationSearchForm.breakpoints.xs)} {
            flex-basis: 50%;
            max-width: 50%;
        }
    `,
};

locationSearchFormStyles.searchResultDistanceGridItem = {
    width: 11,
    css: css`
        padding-top: 10px;
    `,
};

locationSearchFormStyles.searchResultInformationGridContainer = {
    gap: 0,
    css: css`
        flex-direction: column;
    `,
};
